import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios, { AxiosError } from "axios";
import { IAppointmentLite } from "lobbie";
import { buildStaffResourcePathForCurrentUser } from "../ResourceBuilder";

const appointmentApi = createApi({
    reducerPath: "lobbie/staff/appointments",
    baseQuery: fetchBaseQuery({}),
    endpoints: (builder) => ({
        getAppointmentById: builder.query<IAppointmentLite, number>({
            queryFn: async (id) => {
                const url = buildStaffResourcePathForCurrentUser(`appointments/search/${id}`);
                try {
                    const response = await axios.get<IAppointmentLite>(url, {
                        withCredentials: true,
                    });
                    return { data: response.data };
                } catch (error) {
                    const axiosError = error as AxiosError;
                    return {
                        data: undefined,
                        error: {
                            error: axiosError.message,
                            originalStatus: axiosError.response?.status ?? 0,
                            status: axiosError.status ?? 0,
                            data: axiosError.response?.data,
                        },
                    };
                }
            },
        }),
    }),
});

export const { useGetAppointmentByIdQuery } = appointmentApi;
export default appointmentApi;
